import { SharePermissions } from 'common/models/sharing';

const filterViewPermission = (permissions: SharePermissions[]): SharePermissions[] =>
  permissions.filter((perm) => perm !== SharePermissions.VIEW);

export default filterViewPermission;
